<script setup lang="ts">
const props = defineProps<{
  activeKey: string;
}>();
</script>

<template>
  <div class="ios-keyboard-mock">
    <div class="kb-row">
      <div v-for="k in ['Q','W','E','R','T','Y','U','I','O','P']" :key="k" class="kb-key" :class="{ active: activeKey === k }">{{k}}</div>
    </div>
    <div class="kb-row px-4">
      <div v-for="k in ['A','S','D','F','G','H','J','K','L']" :key="k" class="kb-key" :class="{ active: activeKey === k }">{{k}}</div>
    </div>
    <div class="kb-row">
      <div class="kb-key-special">⇧</div>
      <div v-for="k in ['Z','X','C','V','B','N','M']" :key="k" class="kb-key" :class="{ active: activeKey === k }">{{k}}</div>
      <div class="kb-key-special">⌫</div>
    </div>
    <div class="kb-row">
      <div class="kb-key-wide">123</div>
      <div class="kb-key-space">space</div>
      <div class="kb-key-wide blue">Go</div>
    </div>
    <div class="kb-bottom-safe">
      <div class="home-indicator"></div>
    </div>
  </div>
</template>

<style scoped>
.ios-keyboard-mock {
  position: absolute; bottom: 0; left: 0; right: 0;
  background: #2d2d2d; padding: 10px 4px; display: flex; flex-direction: column; gap: 10px;
  z-index: 200; box-shadow: 0 -10px 30px rgba(0,0,0,0.5);
}
.kb-row { display: flex; justify-content: center; gap: 6px; }
.kb-key { flex: 1; background: #555; height: 40px; border-radius: 6px; display: flex; align-items: center; justify-content: center; color: #fff; font-size: 0.9rem; font-weight: 500; box-shadow: 0 1px 0 rgba(0,0,0,0.4); transition: background 0.1s; }
.kb-key.active { background: #888; transform: scale(1.05); }
.kb-key-special { width: 45px; background: #444; height: 40px; border-radius: 6px; display: flex; align-items: center; justify-content: center; color: #fff; font-size: 1.2rem; }
.kb-key-wide { width: 80px; background: #444; height: 40px; border-radius: 6px; display: flex; align-items: center; justify-content: center; color: #fff; font-size: 0.9rem; }
.kb-key-wide.blue { background: #007aff; }
.kb-key-space { flex: 1; background: #555; height: 40px; border-radius: 6px; display: flex; align-items: center; justify-content: center; color: #fff; font-size: 0.9rem; }
.kb-bottom-safe { height: 30px; display: flex; justify-content: center; align-items: flex-end; padding-bottom: 8px; }
.home-indicator { width: 120px; height: 5px; background: rgba(255,255,255,0.3); border-radius: 10px; }
</style>
